var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1110px",
    height: "360px",
    viewBox: "0 0 1110 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0.640807142,
    y: 0.253043977,
    width: 1.70858144,
    height: 3.75289166
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0.640807142,
    y: 0.253043977,
    width: 1.70858144,
    height: 3.75289166
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0.623699943,
    y: 0.359251167,
    width: 32.774541,
    height: 32.7752538
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0.623699943,
    y: 0.359251167,
    width: 32.774541,
    height: 32.7752538
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0.623699943,
    y: 0.359251167,
    width: 32.774541,
    height: 32.7752538
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0.623699943,
    y: 0.359251167,
    width: 32.774541,
    height: 32.7752538
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0.0342143969,
    y: 0.482565556,
    width: 32.5279122,
    height: 32.528625
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0.0342143969,
    y: 0.482565556,
    width: 32.5279122,
    height: 32.528625
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0.0342143969,
    y: 0.482565556,
    width: 32.5279122,
    height: 32.528625
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-19",
    x: 0.0342143969,
    y: 0.482565556,
    width: 32.5279122,
    height: 32.528625
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Development-Pillar-Page-V1.4",
    transform: "translate(-570.000000, -10090.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(556.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    transform: "translate(14.000000, 9851.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-copy-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E2E8FF",
    points: "0 360 1110 360 1110 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: 4428859,
    transform: "translate(612.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.444675,61.3442104 L157.444675,54.0387239 C157.444675,53.3237856 156.865169,52.7442792 156.150943,52.7442792 L154.270577,52.7442792 C153.719583,52.7442792 153.23274,52.3700593 153.109426,51.8333209 C152.45864,48.9963772 151.350236,46.3340694 149.854782,43.9347848 C149.556831,43.4557833 149.613142,42.8384985 150.01231,42.4400434 L151.334554,41.1170867 C151.839929,40.6117115 151.839929,39.7927044 151.334554,39.2873292 L146.168893,34.1216681 C145.663518,33.616293 144.843798,33.616293 144.338423,34.1216681 L143.017605,35.4417736 C142.619149,35.8409416 142.001152,35.8972528 141.52215,35.5985896 C139.123579,34.1024225 136.460558,32.992593 133.622189,32.3410939 C133.08545,32.2177795 132.71123,31.7302243 132.71123,31.1799428 L132.71123,29.3052789 C132.71123,28.5903406 132.132437,28.0115471 131.417498,28.0115471 L124.111299,28.0115471 C123.397074,28.0115471 122.817567,28.5903406 122.817567,29.3052789 L122.817567,31.1799428 C122.817567,31.7302243 122.443347,32.2177795 121.906609,32.3403811 C119.06824,32.9918802 116.404506,34.1017097 114.005222,35.5978768 C113.52622,35.89654 112.908223,35.8402288 112.509767,35.4410608 L111.190375,34.1216681 C110.685,33.616293 109.86528,33.616293 109.359904,34.1216681 L104.194243,39.2873292 C103.688868,39.7927044 103.688868,40.6117115 104.194243,41.1170867 L105.515062,42.437905 C105.91423,42.8370729 105.970541,43.4543577 105.67259,43.9333592 C104.177136,46.3333566 103.068732,48.9963772 102.417233,51.8333209 C102.293919,52.3700593 101.807076,52.7442792 101.256795,52.7442792 L99.3778542,52.7442792 C98.6636286,52.7442792 98.0841223,53.3237856 98.0841223,54.0387239 L98.0841223,61.3442104 C98.0841223,62.0591488 98.6636286,62.6386551 99.3778542,62.6386551 L101.257508,62.6386551 C101.807789,62.6386551 102.294632,63.0121623 102.417946,63.5489006 C103.070158,66.3865572 104.179275,69.0488649 105.674016,71.4474367 C105.972679,71.9264383 105.916368,72.543723 105.5172,72.942891 L104.194243,74.2651349 C103.688868,74.77051 103.688868,75.5902299 104.194243,76.0956051 L109.359904,81.2612662 C109.86528,81.7666414 110.685,81.7666414 111.190375,81.2612662 L112.514044,79.9375967 C112.912499,79.5384288 113.530497,79.4821176 114.008786,79.780068 C116.407357,81.2740966 119.069665,82.3810749 121.906609,83.0325741 C122.443347,83.1558885 122.817567,83.6427308 122.817567,84.1930124 L122.817567,86.0776554 C122.817567,86.7925937 123.397074,87.3713873 124.111299,87.3713873 L131.417498,87.3713873 C132.132437,87.3713873 132.71123,86.7925937 132.71123,86.0776554 L132.71123,84.1930124 C132.71123,83.642018 133.08545,83.1551757 133.622189,83.0318613 C136.459132,82.3810749 139.120727,81.2733838 141.519299,79.7793552 C141.997588,79.4814048 142.614873,79.537716 143.014041,79.9368839 L144.338423,81.2612662 C144.843798,81.7666414 145.663518,81.7666414 146.168893,81.2612662 L151.334554,76.0956051 C151.839929,75.5902299 151.839929,74.77051 151.333841,74.2651349 L150.010885,72.9421782 C149.611717,72.5430102 149.554693,71.9257255 149.853356,71.4467239 C151.348097,69.0481521 152.457214,66.3865572 153.108713,63.5489006 C153.231315,63.0121623 153.71887,62.6386551 154.269152,62.6386551 L156.150943,62.6386551 C156.865169,62.6393679 157.444675,62.0598616 157.444675,61.3442104 Z M127.762973,78.2917417 C116.385973,78.2917417 107.175885,69.0631209 107.175885,57.6861212 C107.175885,46.3262286 116.385973,37.0976078 127.762973,37.0976078 C139.139973,37.0976078 148.350774,46.3262286 148.350774,57.6861212 C148.351487,69.0624081 139.139973,78.2917417 127.762973,78.2917417 Z",
    id: "Shape",
    stroke: "#DEE3FC",
    strokeWidth: 0.563111949
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.04749,86.0769426 L191.04749,81.098035 C191.04749,80.6104799 190.652599,80.2163015 190.165756,80.2163015 L188.884142,80.2163015 C188.509209,80.2163015 188.177044,79.9611191 188.092934,79.5954528 C187.649573,77.6616266 186.894005,75.8475507 185.875414,74.2123877 C185.671553,73.8859253 185.710044,73.4653733 185.982333,73.1937966 L186.883313,72.2921046 C187.227595,71.9478223 187.227595,71.3896999 186.883313,71.0454176 L183.362794,67.5248987 C183.018511,67.1799035 182.460389,67.1799035 182.116107,67.5248987 L181.21584,68.4244522 C180.943551,68.6967418 180.522999,68.735233 180.196536,68.5313722 C178.561373,67.5120683 176.746585,66.7557875 174.812759,66.3110004 C174.447092,66.22689 174.19191,65.895438 174.19191,65.5197925 L174.19191,64.242455 C174.19191,63.7556126 173.797019,63.3607215 173.310176,63.3607215 L168.331269,63.3607215 C167.844426,63.3607215 167.449535,63.7556126 167.449535,64.242455 L167.449535,65.5197925 C167.449535,65.895438 167.194353,66.22689 166.828686,66.3110004 C164.894147,66.7550747 163.078646,67.5113555 161.443483,68.5306594 C161.117021,68.7345202 160.696469,68.696029 160.424892,68.4237394 L159.525338,67.5248987 C159.181056,67.1806163 158.622934,67.1806163 158.277938,67.5248987 L154.758132,71.0454176 C154.41385,71.3896999 154.41385,71.9478223 154.758132,72.2921046 L155.658399,73.192371 C155.929975,73.4639477 155.968467,73.8852125 155.765319,74.2116749 C154.746015,75.8468379 153.990447,77.6616266 153.547085,79.5954528 C153.462975,79.9611191 153.13081,80.2163015 152.755877,80.2163015 L151.475689,80.2163015 C150.988846,80.2163015 150.593955,80.6104799 150.593955,81.098035 L150.593955,86.0769426 C150.593955,86.5637849 150.988846,86.9586761 151.475689,86.9586761 L152.75659,86.9586761 C153.131523,86.9586761 153.462975,87.2138585 153.547085,87.5788121 C153.991872,89.5133511 154.74744,91.3274269 155.766031,92.9618772 C155.969892,93.2883395 155.931401,93.7088915 155.659111,93.9811811 L154.758132,94.8821602 C154.41385,95.2264426 154.41385,95.7852777 154.758132,96.1295601 L158.277938,99.650079 C158.622934,99.9943613 159.181056,99.9943613 159.525338,99.650079 L160.427743,98.7476742 C160.69932,98.4760975 161.119872,98.4376063 161.446334,98.6407542 C163.080784,99.6586326 164.89486,100.413488 166.828686,100.856849 C167.194353,100.94096 167.449535,101.273124 167.449535,101.648057 L167.449535,102.932523 C167.449535,103.419365 167.844426,103.814256 168.331269,103.814256 L173.310176,103.814256 C173.797019,103.814256 174.19191,103.419365 174.19191,102.932523 L174.19191,101.648057 C174.19191,101.272412 174.447092,100.94096 174.812759,100.856849 C176.745872,100.413488 178.559948,99.6579198 180.194398,98.6400414 C180.52086,98.4368935 180.941412,98.4753847 181.212989,98.7476742 L182.116107,99.650079 C182.460389,99.9943613 183.018511,99.9943613 183.362794,99.650079 L186.883313,96.1295601 C187.227595,95.7852777 187.227595,95.2264426 186.883313,94.8821602 L185.980908,93.9804683 C185.709331,93.7088915 185.67084,93.2876267 185.873988,92.9611644 C186.892579,91.3267141 187.648147,89.5126383 188.092221,87.5795249 C188.176332,87.2138585 188.508496,86.9586761 188.883429,86.9586761 L190.165756,86.9586761 C190.652599,86.9586761 191.04749,86.5637849 191.04749,86.0769426 M170.819653,96.8338064 C163.504188,96.8338064 157.581533,90.899747 157.581533,83.5835684 C157.581533,76.2787947 163.504188,70.3447352 170.819653,70.3447352 C178.135832,70.3447352 184.058486,76.2787947 184.058486,83.5835684 C184.058486,90.899747 178.135832,96.8338064 170.819653,96.8338064",
    id: "Shape",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7036037,215.493612 C99.7036037,216.826548 98.622999,217.907152 97.2900632,217.907152 C95.9571273,217.907152 94.8765226,216.826548 94.8765226,215.493612 C94.8765226,214.160676 95.9571273,213.080071 97.2900632,213.080071 C98.622999,213.080784 99.7036037,214.160676 99.7036037,215.493612",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.052464,149.544649 C423.052464,150.876872 421.971146,151.958189 420.638211,151.958189 C419.305987,151.958189 418.22467,150.876872 418.22467,149.544649 C418.22467,148.211713 419.305987,147.130395 420.638211,147.130395 C421.971146,147.130395 423.052464,148.211713 423.052464,149.544649",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.22467,63.3607215 C418.22467,64.6936573 417.144065,65.774262 415.811129,65.774262 C414.478194,65.774262 413.397589,64.6936573 413.397589,63.3607215 C413.397589,62.0277856 414.478194,60.9471809 415.811129,60.9471809 C417.144065,60.9471809 418.22467,62.0277856 418.22467,63.3607215",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.546001,34.0674953 C330.546001,34.9036096 329.868128,35.5814824 329.032014,35.5814824 C328.1959,35.5814824 327.518027,34.9036096 327.518027,34.0674953 C327.518027,33.231381 328.1959,32.5535083 329.032014,32.5535083 C329.868128,32.5535083 330.546001,33.231381 330.546001,34.0674953",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.738939,13.9002468 C106.738939,14.7363611 106.061066,15.4142338 105.224952,15.4142338 C104.388838,15.4142338 103.710965,14.7363611 103.710965,13.9002468 C103.710965,13.0641324 104.388838,12.3862597 105.224952,12.3862597 C106.061066,12.3862597 106.738939,13.0641324 106.738939,13.9002468",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.247664,107.131627 C140.247664,107.967741 139.569791,108.645614 138.733677,108.645614 C137.897563,108.645614 137.21969,107.967741 137.21969,107.131627 C137.21969,106.295513 137.897563,105.61764 138.733677,105.61764 C139.569791,105.61764 140.247664,106.295513 140.247664,107.131627",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7055803,217.907152 C84.7055803,218.743267 84.0277076,219.421139 83.1915932,219.421139 C82.3554789,219.421139 81.6776062,218.743267 81.6776062,217.907152 C81.6776062,217.071038 82.3554789,216.393165 83.1915932,216.393165 C84.0277076,216.393165 84.7055803,217.071038 84.7055803,217.907152",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.646978,216.919211 C387.646978,218.252147 386.565661,219.333465 385.232725,219.333465 C383.900502,219.333465 382.819184,218.252147 382.819184,216.919211 C382.819184,215.586276 383.900502,214.505671 385.232725,214.505671 C386.565661,214.506384 387.646978,215.586276 387.646978,216.919211",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.968574,216.919211 C438.968574,218.252147 437.887256,219.333465 436.55432,219.333465 C435.222097,219.333465 434.14078,218.252147 434.14078,216.919211 C434.14078,215.586276 435.222097,214.505671 436.55432,214.505671 C437.887256,214.506384 438.968574,215.586276 438.968574,216.919211",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.764314,7.31896495 C150.764314,8.65190083 149.68371,9.73250553 148.350774,9.73250553 C147.017838,9.73250553 145.937233,8.65190083 145.937233,7.31896495 C145.937233,5.98602907 147.017838,4.90542437 148.350774,4.90542437 C149.68371,4.90613717 150.764314,5.98674187 150.764314,7.31896495",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.879371,117.13221 C314.879371,118.915636 313.433813,120.361907 311.649675,120.361907 C309.866249,120.361907 308.421404,118.915636 308.421404,117.13221 C308.421404,115.348785 309.866249,113.902514 311.649675,113.902514 C313.433813,113.902514 314.879371,115.348785 314.879371,117.13221",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6851554,77.196881 C76.6851554,78.9803064 75.2395972,80.4265775 73.4554589,80.4265775 C71.6720335,80.4265775 70.2264752,78.9803064 70.2264752,77.196881 C70.2264752,75.4134556 71.6720335,73.9671845 73.4554589,73.9671845 C75.2395972,73.9671845 76.6851554,75.4134556 76.6851554,77.196881",
    id: "Path",
    fill: "#A4AFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5983819,28.9902214 L63.5368478,28.9902214 C63.275963,28.9902214 63.0635487,28.7785198 63.0635487,28.5169222 L63.0635487,24.4553882 C63.0635487,24.1945034 63.275963,23.982089 63.5368478,23.982089 L67.5983819,23.982089 C67.8599794,23.982089 68.0716828,24.1945034 68.0716828,24.4553882 L68.0716828,28.5169222 C68.0723938,28.7785198 67.8599794,28.9902214 67.5983819,28.9902214",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2972756,28.9902214 L70.2357416,28.9902214 C69.9748568,28.9902214 69.7624425,28.7785198 69.7624425,28.5169222 L69.7624425,24.4553882 C69.7624425,24.1945034 69.9748568,23.982089 70.2357416,23.982089 L74.2972756,23.982089 C74.5588732,23.982089 74.7705748,24.1945034 74.7705748,24.4553882 L74.7705748,28.5169222 C74.7705748,28.7785198 74.5588732,28.9902214 74.2972756,28.9902214",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9961694,28.9902214 L76.9346354,28.9902214 C76.6737506,28.9902214 76.4613362,28.7785198 76.4613362,28.5169222 L76.4613362,24.4553882 C76.4613362,24.1945034 76.6737506,23.982089 76.9346354,23.982089 L80.9961694,23.982089 C81.257767,23.982089 81.4694686,24.1945034 81.4694686,24.4553882 L81.4694686,28.5169222 C81.4694686,28.7785198 81.257767,28.9902214 80.9961694,28.9902214",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.729462,204.861488 L404.668641,204.861488 C404.407756,204.861488 404.195342,204.649073 404.195342,204.388189 L404.195342,200.326655 C404.195342,200.06577 404.407756,199.853355 404.668641,199.853355 L408.729462,199.853355 C408.99106,199.853355 409.202761,200.06577 409.202761,200.326655 L409.202761,204.388189 C409.202761,204.649786 408.99106,204.861488 408.729462,204.861488",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.428356,204.861488 L411.366822,204.861488 C411.105937,204.861488 410.893523,204.649073 410.893523,204.388189 L410.893523,200.326655 C410.893523,200.06577 411.105937,199.853355 411.366822,199.853355 L415.428356,199.853355 C415.689953,199.853355 415.901657,200.06577 415.901657,200.326655 L415.901657,204.388189 C415.902368,204.649786 415.690666,204.861488 415.428356,204.861488",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.12725,204.861488 L418.067141,204.861488 C417.805544,204.861488 417.592416,204.649073 417.592416,204.388189 L417.592416,200.326655 C417.592416,200.06577 417.805544,199.853355 418.067141,199.853355 L422.12725,199.853355 C422.388847,199.853355 422.600549,200.06577 422.600549,200.326655 L422.600549,204.388189 C422.600549,204.649786 422.388847,204.861488 422.12725,204.861488",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0428382,202.117208 L94.9813042,202.117208 C94.7204194,202.117208 94.508005,201.905506 94.508005,201.643909 L94.508005,197.583088 C94.508005,197.32149 94.7204194,197.109076 94.9813042,197.109076 L99.0428382,197.109076 C99.3044358,197.109076 99.5161374,197.32149 99.5161374,197.583088 L99.5161374,201.643909 C99.5161374,201.905506 99.303723,202.117208 99.0428382,202.117208",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.741732,202.117208 L101.680198,202.117208 C101.419313,202.117208 101.206899,201.905506 101.206899,201.643909 L101.206899,197.583088 C101.206899,197.32149 101.419313,197.109076 101.680198,197.109076 L105.741732,197.109076 C106.00333,197.109076 106.215031,197.32149 106.215031,197.583088 L106.215031,201.643909 C106.214318,201.905506 106.002617,202.117208 105.741732,202.117208",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.440626,202.117208 L108.379092,202.117208 C108.118207,202.117208 107.905793,201.905506 107.905793,201.643909 L107.905793,197.583088 C107.905793,197.32149 108.118207,197.109076 108.379092,197.109076 L112.440626,197.109076 C112.702223,197.109076 112.913925,197.32149 112.913925,197.583088 L112.913925,201.643909 C112.913212,201.905506 112.701511,202.117208 112.440626,202.117208",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.594407,245.160345 L184.15115,245.160345 C175.746526,245.160345 168.933585,238.347403 168.933585,229.942779 L168.933585,15.274525 C168.933585,6.87061379 175.746526,0.0569592089 184.15115,0.0569592089 L280.594407,0.0569592089 C288.998319,0.0569592089 295.811973,6.87061379 295.811973,15.274525 L295.811973,229.942779 C295.811973,238.347403 288.998319,245.160345 280.594407,245.160345",
    id: "Path",
    fill: "#3945BA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.106852,241.676892 L184.637993,241.676892 C177.276908,241.676892 171.309347,235.709331 171.309347,228.347533 L171.309347,15.5325586 C171.309347,8.17076087 177.276908,2.20319981 184.637993,2.20319981 L280.106852,2.20319981 C287.46865,2.20319981 293.436211,8.17076087 293.436211,15.5325586 L293.436211,228.347533 C293.436211,235.709331 287.46865,241.676892 280.106852,241.676892",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.090211,15.1148578 L288.090211,227.682491 C288.090211,232.6671 284.048636,236.709389 279.063313,236.709389 L185.682245,236.709389 C180.696922,236.709389 176.655346,232.6671 176.655346,227.682491 L176.655346,15.1148578 C176.655346,10.1295351 180.696922,6.08795946 185.682245,6.08795946 L201.254072,6.08795946 C202.118698,6.08795946 202.908481,6.57551462 203.295531,7.34818975 L204.949227,10.6491662 C205.702656,12.1724197 207.257986,13.1268588 208.94946,13.1268588 L255.79681,13.1268588 C257.488285,13.1268588 259.043614,12.1724197 259.796331,10.6491662 L261.450027,7.34818975 C261.837077,6.57551462 262.626859,6.08795946 263.491486,6.08795946 L279.063313,6.08795946 C284.048636,6.08795946 288.090211,10.1295351 288.090211,15.1148578",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.032514,9.26490877 L214.301162,9.26490877 C213.423705,9.26490877 212.712331,8.55353444 212.712331,7.67607772 C212.712331,6.798621 213.423705,6.08724666 214.301162,6.08724666 L252.032514,6.08724666 C252.909971,6.08724666 253.621345,6.798621 253.621345,7.67607772 C253.621345,8.55353444 252.909971,9.26490877 252.032514,9.26490877",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.266824,229.33191 L189.304694,229.33191 C186.006569,229.33191 183.332143,226.658197 183.332143,223.359359 L183.332143,193.711871 C183.332143,190.413033 186.006569,187.738608 189.304694,187.738608 L273.266824,187.738608 C276.565662,187.738608 279.239375,190.413033 279.239375,193.711871 L279.239375,223.359359 C279.239375,226.658197 276.565662,229.33191 273.266824,229.33191 Z",
    id: "Path",
    stroke: "#698BD1",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.022213238551529,2.022213238551529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.010696,127.268225 L227.359657,127.268225 C224.980331,127.268225 223.051494,125.339389 223.051494,122.960062 L223.051494,102.3744 C223.051494,99.9950741 224.980331,98.0662375 227.359657,98.0662375 L269.010696,98.0662375 C271.390022,98.0662375 273.318858,99.9950741 273.318858,102.3744 L273.318858,122.960062 C273.318858,125.339389 271.390022,127.268225 269.010696,127.268225 Z",
    id: "Path",
    stroke: "#698BD1",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.022213238551529,2.022213238551529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.978432,180.820884 L191.95631,180.820884 C189.121504,180.820884 186.823437,178.522817 186.823437,175.688012 L186.823437,139.406495 C186.823437,136.570977 189.121504,134.273623 191.95631,134.273623 L277.978432,134.273623 C280.813237,134.273623 283.111304,136.57169 283.111304,139.406495 L283.111304,175.688012 C283.111304,178.522817 280.813237,180.820884 277.978432,180.820884",
    id: "Path",
    fill: "#DFA810",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.239375,135.63222 L279.239375,171.93512 C279.239375,174.764936 276.944159,177.053024 274.114343,177.053024 L188.457175,177.053024 C185.627359,177.053024 183.332143,174.764936 183.332143,171.93512 L183.332143,135.63222 C183.332143,132.801691 185.627359,130.507188 188.457175,130.507188 L274.114343,130.507188 C276.944159,130.507188 279.239375,132.802404 279.239375,135.63222",
    id: "Path",
    fill: "#F7B500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.463084,173.270195 L191.227828,173.270195 C189.314673,173.270195 187.762908,171.719142 187.762908,169.805274 L187.762908,144.570731 C187.762908,142.656863 189.314673,141.106523 191.227828,141.106523 L216.463084,141.106523 C218.376952,141.106523 219.928005,142.657576 219.928005,144.570731 L219.928005,169.805274 C219.928718,171.719142 218.376952,173.270195 216.463084,173.270195",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.371457,145.175185 L224.147068,145.175185 C223.542613,145.175185 223.052207,144.685492 223.052207,144.081037 C223.052207,143.476583 223.542613,142.987602 224.147068,142.987602 L246.371457,142.987602 C246.975911,142.987602 247.465605,143.477296 247.465605,144.081037 C247.465605,144.686204 246.975198,145.175185 246.371457,145.175185",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.243283,149.544649 L224.146355,149.544649 C223.5419,149.544649 223.052207,149.054242 223.052207,148.450501 C223.052207,147.845334 223.5419,147.356353 224.146355,147.356353 L236.243283,147.356353 C236.84845,147.356353 237.33743,147.846047 237.33743,148.450501 C237.33743,149.054955 236.847737,149.544649 236.243283,149.544649",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42863,149.544649 L240.695431,149.544649 C240.090977,149.544649 239.601283,149.054242 239.601283,148.450501 C239.601283,147.845334 240.091689,147.356353 240.695431,147.356353 L273.42863,147.356353 C274.033084,147.356353 274.522777,147.846047 274.522777,148.450501 C274.522777,149.054955 274.032371,149.544649 273.42863,149.544649",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.863056,153.9134 L224.146355,153.9134 C223.542613,153.9134 223.052207,153.422993 223.052207,152.819252 C223.052207,152.21551 223.542613,151.725104 224.146355,151.725104 L242.863056,151.725104 C243.46751,151.725104 243.957203,152.21551 243.957203,152.819252 C243.957203,153.422993 243.466797,153.9134 242.863056,153.9134",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.74994,153.9134 L246.983039,153.9134 C246.379298,153.9134 245.889604,153.422993 245.889604,152.819252 C245.889604,152.21551 246.38001,151.725104 246.983039,151.725104 L258.74994,151.725104 C259.354395,151.725104 259.843376,152.21551 259.843376,152.819252 C259.843376,153.422993 259.354395,153.9134 258.74994,153.9134",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42863,153.9134 L262.593358,153.9134 C261.988903,153.9134 261.49921,153.422993 261.49921,152.819252 C261.49921,152.21551 261.989616,151.725104 262.593358,151.725104 L273.42863,151.725104 C274.033084,151.725104 274.522777,152.21551 274.522777,152.819252 C274.522777,153.422993 274.032371,153.9134 273.42863,153.9134",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42863,158.28215 L224.146355,158.28215 C223.542613,158.28215 223.052207,157.792457 223.052207,157.188003 C223.052207,156.583548 223.542613,156.094567 224.146355,156.094567 L273.42863,156.094567 C274.033084,156.094567 274.522777,156.584261 274.522777,157.188003 C274.522777,157.792457 274.032371,158.28215 273.42863,158.28215",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.269818,162.650901 L224.146355,162.650901 C223.542613,162.650901 223.052207,162.161208 223.052207,161.557466 C223.052207,160.952299 223.542613,160.463318 224.146355,160.463318 L251.269818,160.463318 C251.874272,160.463318 252.363966,160.953012 252.363966,161.557466 C252.363966,162.161208 251.87356,162.650901 251.269818,162.650901",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42863,162.650901 L255.642846,162.650901 C255.038391,162.650901 254.548698,162.161208 254.548698,161.557466 C254.548698,160.952299 255.039104,160.463318 255.642846,160.463318 L273.42863,160.463318 C274.033084,160.463318 274.522777,160.953012 274.522777,161.557466 C274.522777,162.161208 274.032371,162.650901 273.42863,162.650901",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.082423,167.020365 L224.146355,167.020365 C223.5419,167.020365 223.052207,166.529958 223.052207,165.926217 C223.052207,165.322475 223.5419,164.832069 224.146355,164.832069 L240.082423,164.832069 C240.686877,164.832069 241.176571,165.322475 241.176571,165.926217 C241.176571,166.529958 240.686877,167.020365 240.082423,167.020365",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.332356,167.020365 L244.396288,167.020365 C243.791834,167.020365 243.30214,166.529958 243.30214,165.926217 C243.30214,165.322475 243.792547,164.832069 244.396288,164.832069 L260.332356,164.832069 C260.936811,164.832069 261.426504,165.322475 261.426504,165.926217 C261.426504,166.529958 260.936098,167.020365 260.332356,167.020365",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42863,167.020365 L264.181476,167.020365 C263.577022,167.020365 263.087328,166.529958 263.087328,165.926217 C263.087328,165.322475 263.577734,164.832069 264.181476,164.832069 L273.42863,164.832069 C274.033084,164.832069 274.522777,165.322475 274.522777,165.926217 C274.522777,166.529958 274.032371,167.020365 273.42863,167.020365",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.371457,171.389116 L224.147068,171.389116 C223.542613,171.389116 223.052207,170.899422 223.052207,170.294968 C223.052207,169.690513 223.542613,169.20082 224.147068,169.20082 L246.371457,169.20082 C246.975911,169.20082 247.465605,169.691226 247.465605,170.294968 C247.465605,170.899422 246.975198,171.389116 246.371457,171.389116",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42863,145.175185 L251.20424,145.175185 C250.599073,145.175185 250.10938,144.685492 250.10938,144.081037 C250.10938,143.476583 250.599786,142.987602 251.20424,142.987602 L273.42863,142.987602 C274.033084,142.987602 274.522777,143.477296 274.522777,144.081037 C274.522777,144.686204 274.032371,145.175185 273.42863,145.175185",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.239375,135.63222 L279.239375,137.157612 L183.332143,137.157612 L183.332143,135.63222 C183.332143,132.801691 185.627359,130.507188 188.457175,130.507188 L274.114343,130.507188 C276.944159,130.507188 279.239375,132.802404 279.239375,135.63222",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.162055,133.95215 C261.162055,134.607926 260.630307,135.140388 259.973818,135.140388 C259.318042,135.140388 258.786293,134.607926 258.786293,133.95215 C258.786293,133.296374 259.318042,132.763913 259.973818,132.763913 C260.630307,132.763913 261.162055,133.296374 261.162055,133.95215",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.240813,133.95215 C267.240813,134.607926 266.709065,135.140388 266.052576,135.140388 C265.3968,135.140388 264.865051,134.607926 264.865051,133.95215 C264.865051,133.296374 265.3968,132.763913 266.052576,132.763913 C266.709065,132.763913 267.240813,133.296374 267.240813,133.95215",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.318858,133.95215 C273.318858,134.607926 272.78711,135.140388 272.130621,135.140388 C271.474845,135.140388 270.943096,134.607926 270.943096,133.95215 C270.943096,133.296374 271.474845,132.763913 272.130621,132.763913 C272.78711,132.763913 273.318858,133.296374 273.318858,133.95215",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.024537,127.268225 L194.043388,127.268225 C191.227828,127.268225 188.946156,124.986553 188.946156,122.170993 L188.946156,103.189843 C188.946156,100.374996 191.227828,98.0926111 194.043388,98.0926111 L213.024537,98.0926111 C215.839384,98.0926111 218.12177,100.374996 218.12177,103.189843 L218.12177,122.170993 C218.122483,124.986553 215.840097,127.268225 213.024537,127.268225 Z",
    id: "Path",
    stroke: "#495AD6",
    strokeWidth: 0.638668742
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#495AD6",
    strokeWidth: 1.19180149,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "198.983092 108.460999 194.77971 112.66438 199.01588 116.90055"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#495AD6",
    strokeWidth: 1.19180149,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "208.085547 108.460999 212.288215 112.66438 208.052045 116.90055"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.50236,
    y1: 108.460999,
    x2: 201.565566,
    y2: 116.90055,
    id: "Path",
    stroke: "#495AD6",
    strokeWidth: 1.19180149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.239375,26.8803336 L279.239375,86.2351842 C279.239375,89.4570399 276.630527,92.0658876 273.408671,92.0658876 L189.162847,92.0658876 C185.948119,92.0658876 183.332143,89.4570399 183.332143,86.2351842 L183.332143,26.8803336 C183.332143,23.6584779 185.948119,21.0496301 189.162847,21.0496301 L273.408671,21.0496301 C276.630527,21.0496301 279.239375,23.6584779 279.239375,26.8803336",
    id: "Path",
    fill: "#B2C1F9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.715175,39.8033964 C273.715175,47.4802517 267.492432,53.7029951 259.815576,53.7029951 C252.138721,53.7029951 245.915978,47.4802517 245.915978,39.8033964 C245.915978,32.1265411 252.138721,25.9037977 259.815576,25.9037977 C267.492432,25.9037977 273.715175,32.1265411 273.715175,39.8033964",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.70749,92.0658876 L189.162847,92.0658876 C185.948119,92.0658876 183.332143,89.4570399 183.332143,86.2351842 L183.332143,76.890377 L205.450325,38.5773805 C206.605061,36.5744127 209.499029,36.5744127 210.653765,38.5773805 L227.354667,67.5028019 L239.757386,88.9865919 C240.356138,90.0130238 240.263474,91.1820157 239.70749,92.0658876",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.504912,92.0658876 L213.169949,92.0658876 L227.354667,67.5028019 L234.995883,54.2661071 C236.036571,52.4627232 238.63829,52.4627232 239.678978,54.2661071 L261.504912,92.0658876 Z",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3B47BC",
    fillRule: "nonzero",
    x: 320.113461,
    y: 202.357422,
    width: 37.2623294,
    height: 55.9997013
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#495AD6",
    fillRule: "nonzero",
    x: 357.375791,
    y: 202.357422,
    width: 14.2681163,
    height: 55.9997013
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 204.508652,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 208.347792,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 212.186933,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 216.026073,
    width: 10.474595,
    height: 1.78770224
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 219.865926,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 223.705067,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 227.544207,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 231.384061,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 235.223201,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 239.062341,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 242.901482,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 246.741335,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 250.580476,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B2C1F9",
    fillRule: "nonzero",
    x: 359.417963,
    y: 254.419616,
    width: 10.474595,
    height: 1.78698944
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.060364,258.357123 L332.99732,258.357123 C332.99732,258.357123 334.055828,254.984866 331.762751,250.807146 C331.762751,250.807146 330.238072,252.029598 325.672588,251.20275 C325.672588,251.20275 323.766561,252.821519 322.450732,253.453059 C321.128488,254.093154 313.549287,255.582193 314.060364,258.357123",
    id: "Path",
    fill: "#281616",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38047,204.957716 C316.603634,212.256074 322.247584,236.948177 324.673955,251.53634 C329.108284,251.913412 331.23813,251.404472 332.366492,251.1443 C332.144811,246.05776 331.707865,233.890265 331.758474,228.55567 C331.843297,219.538038 332.2667,207.645684 328.297117,201.120001 L314.948513,202.170668 C315.029772,202.875627 315.103903,203.448718 315.169481,203.858578 C315.233633,204.250618 315.307051,204.614859 315.38047,204.957716",
    id: "Path",
    fill: "#002C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.805338,258.357123 L298.743006,258.357123 C298.743006,258.357123 299.801514,254.984866 297.507724,250.807146 C297.507724,250.807146 295.983758,252.029598 291.417562,251.20275 C291.417562,251.20275 289.512247,252.821519 288.196419,253.453059 C286.873462,254.093154 279.294973,255.582193 279.805338,258.357123",
    id: "Path",
    fill: "#281616",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.868706,251.10866 C294.487591,252.003937 297.108556,251.916976 298.349541,251.777267 C299.356727,245.913774 300.947697,233.012808 302.378999,226.965414 C304.600084,217.565721 306.774123,204.64052 305.2637,200.027991 L292.133213,196.730579 C292.089732,197.146854 291.020532,236.707963 290.868706,251.10866",
    id: "Path",
    fill: "#052635",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.126207,183.272203 L343.126207,183.272203 C342.862471,180.676899 342.558818,178.781564 342.558818,178.781564 L327.889396,182.371937 L315.42894,185.211019 C310.809284,186.239589 305.227347,187.479149 300.308315,188.591116 C294.78768,189.845644 291.12175,194.039046 292.331371,199.56681 L293.715628,206.272119 C301.436677,206.167337 337.741716,202.686022 340.846673,201.119288 C344.355074,199.34798 345.410731,193.083894 343.126207,183.272203",
    id: "Path",
    fill: "#052635",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.024847,183.272203 L365.024847,183.272203 C364.761111,180.676899 363.495891,177.892702 363.495891,177.892702 L349.788035,182.371937 L337.32758,185.211019 C332.707923,186.239589 327.125987,187.479149 322.206955,188.591116 C316.686319,189.845644 313.020389,194.039046 314.230011,199.56681 L315.614268,206.272119 C323.33603,206.167337 355.60876,205.041826 362.745313,201.119288 C366.188849,199.226092 367.309371,193.083894 365.024847,183.272203",
    id: "Path",
    fill: "#002C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.965432,162.247456 C323.965432,162.247456 330.481136,159.304306 332.273828,162.256723 C333.255354,163.873353 332.576768,166.874954 330.354971,168.134471 C328.132461,169.394701 315.575064,174.705774 303.72334,177.667457 C303.72334,177.667457 303.216539,176.018751 302.401809,174.286647 C302.401809,174.286647 307.718583,172.079819 313.003282,168.367557 C318.288693,164.655295 323.965432,162.247456 323.965432,162.247456",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59418,141.901295 L320.010105,164.205518 C320.010105,164.205518 320.58676,169.844478 326.281319,167.075963 C331.976591,164.308161 335.750153,146.538771 335.750153,146.538771 L325.59418,141.901295 Z",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.04163,154.375294 C334.350214,154.209212 333.690874,154.026735 333.05577,153.834992 C332.404271,153.644674 331.784847,153.445803 331.196787,153.239091 C325.891418,151.420025 323.023111,149.236006 323.023111,149.236006 C324.691062,141.983267 326.701158,137.114131 328.488148,133.905105 C328.535905,133.825985 328.583663,133.753992 328.62358,133.66703 C328.669912,133.587197 328.718382,133.508076 328.76614,133.428242 C329.727707,131.83157 331.109113,130.489368 332.650187,129.385241 C332.809854,129.274044 332.960255,129.170688 333.118496,129.059491 L333.777836,140.704504 L333.889033,141.904146 L335.04163,154.375294 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.04163,154.375294 C334.350214,154.209212 333.690874,154.026735 333.05577,153.834992 C332.404271,153.644674 331.784847,153.445803 331.196787,153.239091 C332.310894,145.39544 333.318793,140.466429 333.318793,140.466429 L333.890458,141.904146 L335.04163,154.375294 Z",
    id: "Path",
    fill: "#C7E5F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.006489,134.238696 C367.872483,137.686509 367.268741,143.222826 366.74412,148.783378 C366.577325,150.546846 366.418371,152.318153 366.283652,154.025309 C366.188136,155.08952 364.583624,160.769109 364.520184,161.786275 C364.234352,166.64757 361.850749,170.285701 364.10676,177.689554 C364.647063,179.460862 364.782495,180.374672 364.782495,181.105292 C364.782495,181.613518 364.123155,182.145267 363.860845,182.288539 C362.915672,182.836683 361.055977,183.218031 358.799965,183.496023 L358.792124,183.496023 C354.352093,184.036325 348.362436,184.138968 344.747827,184.138968 C339.894372,184.138968 332.610983,183.368431 331.690045,182.144554 C330.846803,181.024745 331.626606,179.397423 332.023635,177.148539 C333.810625,167.004683 333.17552,161.714282 333.064323,154.390263 C333.064323,154.207786 333.05577,154.024596 333.05577,153.834279 C332.873293,142.538538 332.126279,132.871546 332.650899,129.384528 C332.809854,129.273331 332.960967,129.169975 333.119922,129.058779 C333.890458,128.534871 334.644601,128.065136 335.375221,127.652424 C335.439373,127.620348 335.518493,127.573304 335.597614,127.524833 C335.820008,127.397955 336.050242,127.278917 336.265508,127.15988 C336.343916,127.112122 336.43159,127.072205 336.518552,127.032288 C338.163694,126.230389 340.561553,125.372177 341.936544,124.896027 C342.111893,124.840429 342.270134,124.78483 342.404854,124.744913 C343.699298,124.665793 345.105653,124.648685 346.622491,124.689315 C347.941884,124.729232 349.95982,124.903868 352.152393,125.189701 L352.160234,125.189701 C354.638639,125.506897 357.347279,125.975919 359.499935,126.563979 C359.499935,126.563979 359.523457,126.57182 359.539851,126.578948 C359.944722,126.707252 362.574953,127.691628 365.314956,130.621949 C366.228053,131.593495 367.165385,132.785297 368.006489,134.238696",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.10676,177.689554 C364.647063,179.460149 364.781069,180.374672 364.781069,181.105292 C364.781069,181.613518 364.121729,182.145979 363.860132,182.288539 C362.914246,182.836683 361.055977,183.218031 358.799965,183.49531 C359.729456,183.384826 361.333256,181.910043 361.333969,180.579958 C361.333969,179.649041 360.126486,173.360007 360.460076,169.300612 C360.793666,165.24977 361.453006,158.800356 360.197766,153.63612 C358.934684,148.472598 357.750723,141.68104 357.750723,141.68104 L364.828827,145.954988 C364.828827,145.954988 365.742636,147.233751 366.743407,148.783378 C366.577325,150.546846 366.417658,152.318153 366.282939,154.025309 C366.188136,155.090232 361.850036,170.287127 364.10676,177.689554",
    id: "Path",
    fill: "#C7E5F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.970234,104.385922 C332.970234,104.385922 333.581816,111.788349 336.037412,112.285171 C338.491582,112.782705 337.889979,109.637832 337.889979,109.637832 L337.546409,106.122302 L332.970234,104.385922 Z",
    id: "Path",
    fill: "#002C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.288071,131.212147 C339.482374,130.640482 341.277204,125.970217 341.936544,124.898165 C342.111893,124.842567 342.937315,124.587385 343.001467,124.548181 C343.009308,124.54034 343.016436,124.54034 343.016436,124.54034 C343.17539,124.413462 343.295141,124.222431 343.389943,123.984356 C343.858253,122.75335 343.642987,120.298467 343.628018,120.139513 L343.628018,120.131672 L343.628018,119.686885 C343.706426,119.393212 343.786973,119.11522 343.850412,118.852909 L346.376575,116.867049 L351.722574,112.665093 C351.722574,112.665093 350.300539,119.694726 351.444582,124.127629 C351.531544,124.461219 351.70618,124.929529 352.15168,125.191839 C352.15168,125.19968 352.159521,125.191839 352.159521,125.191839 C352.302081,125.287354 352.476717,125.350793 352.69127,125.382157 C354.002821,126.002293 352.175915,132.150192 344.288071,131.212147",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.523528,117.13221 C348.523528,117.13221 348.478622,121.823859 343.386379,123.981505 C343.859678,122.756914 343.640849,120.300606 343.626593,120.143077 L345.760003,118.467997 L348.523528,117.13221 Z",
    id: "Path",
    fill: "#CC6362",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.143502,105.43944 C334.143502,105.43944 335.254045,120.79814 339.401115,122.103277 C339.401115,122.103277 344.685101,122.600811 348.478622,117.497877 C349.570631,116.02737 350.95275,115.697344 351.403953,113.921759 C352.136711,111.037771 353.170984,105.718858 351.851591,102.513396 C349.974076,97.9479127 334.321702,94.323325 334.143502,105.43944",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91503,99.9786797 C351.846602,97.1887808 349.023201,96.1459545 349.023201,96.1459545 C346.211918,94.8308386 340.369097,95.3982273 334.34665,96.7418552 C332.934594,97.0569128 331.162573,96.1901481 330.175345,96.874436 C328.983544,97.7012839 330.170356,101.479124 330.170356,101.479124 C332.493371,108.515172 341.042693,106.227084 343.612337,105.358894 C344.222494,107.170118 344.144086,109.689153 345.667339,110.987875 C346.535529,111.727761 348.043814,111.749145 349.577759,111.49325 C349.766651,111.852501 350.475887,112.168984 350.619873,112.661529 C351.103151,114.306671 351.03401,116.877741 351.019041,118.862176 L351.744671,118.508627 C351.839474,117.971176 359.337416,100.208914 351.91503,99.9786797",
    id: "Path",
    fill: "#002C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(336.594941, 110.903189) rotate(-9.660133) translate(-336.594941, -110.903189) ",
    cx: 336.594941,
    cy: 110.903189,
    rx: 1.82330438,
    ry: 2.34292475
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(341.598557, 109.966677) rotate(-9.654485) translate(-341.598557, -109.966677) ",
    cx: 341.598557,
    cy: 109.966677,
    rx: 1.82327379,
    ry: 2.34288544
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.397492,110.611516 C338.397492,110.611516 338.617035,110.255116 339.771058,110.354908",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.451957,
    y1: 109.981401,
    x2: 347.735884,
    y2: 109.297113,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.050229,114.734351 C350.999795,115.864139 351.922158,108.603559 349.120142,108.281373 C346.995998,108.037596 346.909036,111.001418 346.909036,111.001418 C346.909036,111.001418 346.366596,114.089267 348.050229,114.734351",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(347.133568, 109.123190)",
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88963263,0.253043977 C1.88963263,0.253043977 1.69788945,0.449063959 1.52325346,0.77338793 C1.34647908,1.0962863 1.19180149,1.53822226 1.16328949,2.01152142 C1.1354903,2.2453198 1.1419055,2.48695897 1.1525975,2.71576775 C1.16043829,2.94528933 1.18823749,3.16198051 1.20320629,3.3530109 C1.22387749,3.54689248 1.24098469,3.70798526 1.25238949,3.82132045 C1.26450709,3.93608124 1.26450709,4.00593564 1.26450709,4.00593564 C1.26450709,4.00593564 1.22102629,3.95390124 1.15901269,3.85553485 C1.1048399,3.75431726 0.99293031,3.61888527 0.918086317,3.43284449 C0.835401524,3.2489421 0.748439932,3.02726132 0.701395136,2.77421735 C0.643658341,2.52402457 0.627263943,2.244607 0.649360741,1.96447662 C0.675734339,1.68505905 0.748439932,1.40564147 0.866764721,1.16614069 C0.979387111,0.924501516 1.1419055,0.729907134 1.29444468,0.587347147 C1.61306625,0.306503972 1.88963263,0.253043977 1.88963263,0.253043977",
    id: "Path",
    fill: "#CC6362",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35010139,1.63159905 C2.35010139,1.63159905 2.2296382,1.64442945 2.06426861,1.70715584 C1.89961183,1.76560544 1.69503825,1.88179183 1.54178626,2.03789501 C1.38425747,2.1918598 1.28375268,2.38217738 1.23171829,2.53043977 C1.17754549,2.67798936 1.16043829,2.78205815 1.16043829,2.78205815 L0.673595939,2.60813496 C0.673595939,2.60813496 0.730619934,2.48410777 0.849657523,2.32016379 C0.964418312,2.1540814 1.15758709,1.95592302 1.38782147,1.83047023 C1.61449185,1.70074065 1.86397183,1.64157825 2.04716141,1.62803505 C2.2310638,1.61092785 2.35010139,1.63159905 2.35010139,1.63159905",
    id: "Path",
    fill: "#CC6362",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M376.411826,165.187043 L376.411113,165.194884 C375.115243,166.698892 370.194785,167.795178 367.827576,165.714515 C367.084126,165.052324 366.244448,163.305964 365.419025,161.13834 C363.321255,155.597746 361.334682,147.309308 361.334682,147.309308 L372.343877,141.683178 C372.343877,141.683178 373.76021,148.033513 374.980524,154.069503 C374.980524,154.069503 374.991928,154.130091 375.013312,154.237011 C375.411767,156.170837 375.780285,158.071874 376.071107,159.704186 C376.082512,159.749093 376.087502,159.787584 376.091779,159.833203 C376.382601,161.781998 376.570067,163.813478 376.411826,165.187043",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.176207,139.597526 C358.239704,144.018311 361.58131,152.397274 361.58131,152.397274 C363.922145,152.78575 367.061316,152.353793 369.662323,151.420025 C372.663924,150.340846 374.809452,148.076994 374.809452,148.076994 C374.809452,148.076994 372.593357,141.847835 370.603932,137.372164 C368.819081,133.354111 367.746317,131.855093 366.973642,131.058895 C365.810352,129.84072 363.932837,128.44292 362.60204,127.807815 L357.176207,139.597526 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.098615,142.485078 L364.638509,139.697318 L359.546979,126.581086 C359.546979,126.581086 360.480747,126.864068 361.708189,127.360889 L361.713891,127.360889 C361.738126,127.373007 361.790874,127.390114 361.879261,127.425754 C361.909198,127.438584 361.944125,127.449276 361.974063,127.467809 C363.072488,127.981738 367.331467,130.490794 370.27747,139.609643 C370.300992,139.686626 370.324514,139.763608 370.34875,139.839878 C370.661669,140.891258 370.891903,141.735926 371.016643,142.172872 C371.028761,142.214214 371.039453,142.254844 371.052283,142.302601 C371.06939,142.361051 371.081508,142.425916 371.098615,142.485078",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.411826,165.187043 L376.411113,165.194884 C376.316311,166.001774 376.095343,166.579854 375.696175,166.785141 C375.632735,166.82577 374.728905,167.363934 374.666179,167.404564 C373.318987,168.227848 370.87836,169.6285 367.841119,170.933636 C360.47647,174.115575 349.778056,177.805741 344.009366,179.496502 C344.009366,179.496502 343.439839,177.867041 342.550978,176.169865 C342.550978,176.169865 347.768673,173.747058 352.897982,169.81953 C358.032992,165.899131 365.419025,161.137627 365.419025,161.137627 L367.284423,158.943629 C367.284423,158.943629 373.9156,152.840636 374.980524,154.06879 C374.980524,154.06879 374.991928,154.129378 375.013312,154.236298 C375.172267,154.872828 375.698313,157.214376 376.071107,159.703473 C376.082512,159.74838 376.087502,159.786871 376.091779,159.83249 C376.382601,161.781998 376.570067,163.813478 376.411826,165.187043",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.314386,175.797783 C343.314386,175.797783 342.018516,176.579012 340.696985,176.30102 C339.967078,176.147055 339.671979,175.848392 339.131676,175.75359 C338.590661,175.657362 337.152231,175.479874 336.439431,175.131315 C335.727344,174.781331 335.449352,174.742839 335.4743,175.457778 C335.499248,176.173429 336.905602,176.792139 337.286237,176.989585 C337.667585,177.187743 338.145874,177.822135 338.197196,177.901969 C338.24923,177.981802 335.854935,179.234905 335.210564,178.980435 C335.210564,178.980435 335.019534,179.557803 335.128592,179.879988 C335.236938,180.200748 335.730195,180.314084 335.767973,180.475889 C335.805752,180.637695 335.654638,180.967721 335.761558,181.225042 C335.867765,181.482363 336.307563,181.483076 336.48505,181.900063 C336.662537,182.317051 336.467943,182.324179 336.59696,182.758987 C336.725977,183.193795 337.281961,183.272203 337.387455,183.496023 C337.492237,183.720555 337.437351,183.983578 337.669724,184.137542 C337.903522,184.29222 340.057603,183.600804 340.843109,183.264363 C341.629327,182.926495 343.729949,179.902085 346.055102,178.872089 L343.314386,175.797783 Z",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.320017,189.296788 L337.571357,189.296788 L337.571357,187.658061 L354.320017,187.658061 C354.772645,187.658061 355.139737,188.025153 355.139737,188.477068 C355.139737,188.928984 354.772645,189.296788 354.320017,189.296788",
    id: "Path",
    fill: "#375F84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.257479,189.296788 L303.32132,189.296788 C302.819509,189.296788 302.379712,188.961772 302.24428,188.479207 L293.661456,157.580042 C293.471138,156.896467 293.98578,156.220733 294.695728,156.220733 L335.248342,156.220733 C336.193515,156.220733 337.022501,156.850135 337.276258,157.761094 L345.828432,188.546923 C345.932501,188.923994 345.649519,189.296788 345.257479,189.296788",
    id: "Path",
    fill: "#375F84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.739928,189.296788 L301.803769,189.296788 C301.301958,189.296788 300.861448,188.961772 300.726729,188.479207 L292.143905,157.580042 C291.952874,156.896467 292.468229,156.220733 293.178177,156.220733 L333.730791,156.220733 C334.675964,156.220733 335.50495,156.850135 335.757994,157.761094 L344.310168,188.546923 C344.414949,188.923994 344.131255,189.296788 343.739928,189.296788",
    id: "Path",
    fill: "#467CDB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53209,169.332688 L182.389822,164.353067 C182.389822,164.353067 182.558043,162.131983 182.822491,161.663673 C183.087653,161.195364 183.770515,159.460409 184.111234,159.27223 C184.451239,159.081912 185.132676,159.27223 185.132676,159.27223 C185.132676,159.27223 185.806985,159.044846 186.109925,159.044846 C186.412152,159.044846 186.978115,159.321413 186.978115,159.321413 C186.978115,159.321413 187.704458,159.272942 188.007398,159.272942 C188.309625,159.272942 188.407279,159.357053 188.407279,159.357053 C188.407279,159.357053 189.577696,158.009861 190.145085,157.55652 C190.712474,157.103179 191.580664,156.266352 191.837272,156.269905 C192.079624,156.27348 192.186544,156.699735 192.010483,157.153075 C191.833708,157.607842 191.06531,158.339174 191.06531,158.339174 L188.852066,161.692898 C188.852066,161.692898 189.230563,161.541785 189.432285,161.415619 C189.634008,161.289453 190.983338,160.02851 191.06531,159.977189 C191.147282,159.927293 191.752449,159.523135 192.105285,159.927293 C192.458121,160.33145 189.787972,163.529784 189.35958,163.958176 C188.930474,164.387282 186.476304,165.630405 186.476304,165.630405 C186.476304,165.630405 183.88385,170.292117 183.632232,170.595057 C183.380614,170.896571 177.53209,169.332688 177.53209,169.332688",
    id: "Path",
    fill: "#E49191",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.104702,146.343464 C182.104702,146.343464 179.391072,162.062128 176.83711,162.427082 C176.83711,162.427082 166.64122,162.837655 164.369527,150.46915 C162.399348,139.741511 170.300735,137.454136 173.99589,138.274569 C177.691757,139.095715 182.898048,139.628889 182.104702,146.343464",
    id: "Path",
    fill: "#E49191",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.092772,159.913037 C173.092772,159.913037 171.664321,161.838309 171.163223,166.502872 C171.163223,166.502872 166.917074,167.109465 163.001664,165.092954 C163.001664,165.092954 165.112264,158.514523 165.370298,151.372268",
    id: "Path",
    fill: "#E49191",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.217337,135.642912 C164.64538,136.873917 165.09088,140.345253 165.09088,140.345253 C162.482032,140.99105 161.921772,142.067377 161.943156,146.883054 C161.96454,151.698017 163.706623,157.48025 164.667477,157.950698 C165.628331,158.421146 171.075548,158.443956 171.531028,158.279299 C171.985794,158.114642 173.891821,153.695996 173.447747,152.919044 C173.002959,152.141379 173.469843,149.085606 174.738627,148.970132 C176.006698,148.853946 175.758644,150.820561 175.758644,150.820561 L176.80147,150.591752 L177.606221,148.617296 C184.969445,149.055668 186.871908,140.664587 186.871908,140.664587 C185.103451,139.511277 175.789294,134.411906 170.217337,135.642912",
    id: "Path",
    fill: "#002C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.364836,242.052537 L113.998806,242.867268 L112.132696,249.445698 L106.030416,247.906763 C106.030416,247.906763 103.548447,244.540922 107.296349,242.052537 C107.4774,241.932074 108.069024,241.985534 108.364836,242.052537",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.415755,225.154902 L142.111636,200.011597 C142.111636,200.011597 139.594739,199.114895 138.305284,200.011597 C138.305284,200.011597 129.655457,204.663329 130.57782,217.927111 C131.273513,227.926268 133.384826,238.771519 134.240186,243.120312 L112.084939,242.302017 C112.084939,242.302017 109.352064,245.550246 111.12052,249.779289 C111.12052,249.779289 138.958922,257.266539 142.880747,257.958668 C146.067676,258.521067 149.556118,258.954449 151.239752,257.511029 C154.207138,254.968472 150.415755,225.154902 150.415755,225.154902",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.597299,242.052537 L140.23127,242.867268 L138.365159,249.445698 L132.262879,247.906763 C132.262879,247.906763 129.78091,244.540922 133.528812,242.052537 C133.70915,241.932074 134.301487,241.985534 134.597299,242.052537",
    id: "Path",
    fill: "#E5918F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.552276,245.501776 C132.42611,246.796221 133.559462,247.963074 133.352037,248.285973 C133.144613,248.608871 129.357507,254.962057 129.357507,254.962057 C129.357507,254.962057 132.216547,256.207318 131.755366,258.006425 L124.514744,258.006425 C124.514744,258.006425 122.623686,256.29927 122.670018,253.855791 C122.670018,253.855791 123.16185,251.04237 124.453443,248.551847 C125.744324,246.061324 128.680347,240.438758 128.680347,240.438758 C128.680347,240.438758 129.571347,240.078794 131.093887,240.48509 C132.877313,240.960528 134.596586,242.051112 134.596586,242.051112 C134.596586,242.051112 132.86377,242.301304 132.552276,245.501776",
    id: "Path",
    fill: "#467CDB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.553519,252.229182 C188.765817,245.5588 171.945877,217.081017 166.255595,209.392044 C154.568528,204.317621 142.112349,200.011597 142.112349,200.011597 C136.960231,201.24189 134.423376,211.622395 137.345143,218.54297 C139.349536,223.289505 152.065887,235.238883 159.853226,242.274218 L138.243271,242.247844 C138.243271,242.247844 135.697862,246.053483 138.004483,249.667379 C138.004483,249.667379 173.945281,257.838917 177.097282,258.300099 C180.249996,258.76128 187.323823,258.300099 187.323823,258.300099 C187.323823,258.300099 192.05824,257.84462 190.553519,252.229182",
    id: "Path",
    fill: "#002C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.320526,245.501776 C106.19436,246.796221 107.327712,247.963074 107.120287,248.285973 C106.912862,248.608871 103.125756,254.962057 103.125756,254.962057 C103.125756,254.962057 105.984797,256.207318 105.523615,258.006425 L98.2829935,258.006425 C98.2829935,258.006425 96.3919352,256.29927 96.4382672,253.855791 C96.4382672,253.855791 96.9300992,251.04237 98.2216927,248.551847 C99.5125734,246.061324 102.448596,240.438758 102.448596,240.438758 C102.448596,240.438758 103.339596,240.078794 104.862137,240.48509 C106.645562,240.960528 108.364836,242.051112 108.364836,242.051112 C108.364836,242.051112 106.632019,242.301304 106.320526,245.501776",
    id: "Path",
    fill: "#467CDB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.611405,164.493489 L206.020565,184.881706 L197.72001,176.607524 L190.848619,186.834777 L192.843746,187.793493 L192.125956,188.39082 C192.125956,188.39082 208.145422,196.192415 210.064992,194.471003 C211.984562,192.750304 220.928776,166.812227 220.928776,166.812227 L217.611405,164.493489 Z",
    id: "Path",
    fill: "#E49191",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.19907,177.901256 C199.19907,177.901256 197.010774,187.132015 192.634182,191.508607 L181.436096,187.246063 C181.436096,187.246063 176.239784,195.985703 171.15752,202.68531 C169.204449,205.272773 168.555801,208.915181 166.260585,209.392757 C166.118025,209.342861 165.982593,209.300093 165.840033,209.264453 C159.617289,207.396917 150.436426,209.378501 142.859363,206.562941 C134.491092,203.448006 136.116276,201.694518 136.116276,201.694518 C136.116276,201.694518 141.191411,192.549295 144.071123,182.862343 C145.354163,178.578416 146.245163,174.60812 146.836787,171.506728 C147.898859,166.018881 152.296834,161.727113 157.842418,160.978673 C157.90657,160.971545 157.963594,160.957289 158.027746,160.950161 C164.371665,160.144697 180.979904,162.104896 184.208887,163.487728 C187.437871,164.871273 199.19907,177.901256 199.19907,177.901256",
    id: "Path",
    fill: "#467CDB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.436096,187.246063 C181.436096,187.246063 176.239784,195.985703 171.15752,202.68531 C169.204449,205.272773 168.555801,208.915181 166.260585,209.392757 C167.265633,209.036357 168.933585,203.747381 169.525209,202.557006 C170.123961,201.373758 171.071984,200.183382 173.124848,196.027758 C175.170584,191.865007 177.947653,185.764865 177.947653,185.764865 L181.436096,187.246063 Z",
    id: "Path",
    fill: "#5996EF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.852513,242.273505 C159.852513,242.273505 160.028575,242.234301 160.339356,242.195097 C160.650137,242.162308 161.095637,242.097444 161.630949,242.076772 C162.702288,242.018323 164.136441,242.061804 165.554913,242.258536 C166.262723,242.360467 166.968395,242.484494 167.619894,242.649864 C168.272819,242.803828 168.874422,242.986305 169.379085,243.17092 C169.887311,243.343418 170.29432,243.537299 170.580152,243.664178 C170.865272,243.795333 171.023514,243.878731 171.023514,243.878731 C171.023514,243.878731 170.843176,243.858772 170.535959,243.805312 C170.232306,243.740447 169.791083,243.681285 169.269313,243.592185 C168.225062,243.417549 166.840804,243.194443 165.450844,243.009115 C164.758003,242.902195 164.060171,242.825925 163.407247,242.734687 C162.751471,242.652715 162.139176,242.575732 161.615268,242.510155 C160.557473,242.36902 159.852513,242.273505 159.852513,242.273505",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.274063,156.987706 C226.087309,156.969886 224.899072,157.922899 224.325268,158.394773 L224.986033,157.12884 C224.986033,157.12884 225.860639,156.284885 226.174983,155.821565 C226.489328,155.358245 226.323959,154.894925 226.075191,154.869977 C225.900555,154.85287 224.855591,155.681856 224.249711,156.175827 L224.383004,155.921357 C224.383004,155.921357 225.256897,155.076689 225.571242,154.613369 C225.885587,154.150762 225.720217,153.686729 225.472163,153.661781 C225.224108,153.637546 223.2133,155.325456 223.2133,155.325456 L222.233913,156.636295 L222.972373,155.202142 C222.972373,155.202142 223.360849,154.726704 223.620308,154.208499 C223.879055,153.68958 223.692301,153.532052 223.548316,153.358841 C223.40433,153.186344 222.050723,154.194243 221.705015,154.597688 C221.359307,154.999707 220.265159,156.634157 220.17891,156.865104 L219.047697,159.205226 C218.975704,158.528066 218.861656,157.366915 218.781823,156.627742 C218.667062,155.562106 217.701931,155.310487 217.668429,155.828693 C217.634927,156.347611 217.097476,158.895871 217.219365,160.27799 C217.341254,161.660109 217.572201,162.567504 217.659163,163.345168 C217.745411,164.122833 216.939235,165.676737 216.939235,165.676737 C216.939235,165.676737 220.164654,167.679705 220.697829,167.08024 C221.231003,166.480775 222.365781,165.149265 222.914637,164.252563 C223.668066,163.020132 224.177005,161.401363 224.177005,161.401363 L225.184904,159.247994 C225.184904,159.247994 226.058797,158.404039 226.373142,157.940719 C226.686774,157.476686 226.522117,157.013367 226.274063,156.987706",
    id: "Path",
    fill: "#E49191",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.42242,92.0687388 L373.598404,92.0687388 C371.174172,92.0687388 369.209695,94.0339283 369.209695,96.4581608 L369.209695,105.393108 C369.209695,107.629874 370.882637,109.475313 373.044559,109.747603 C373.361755,109.78752 373.598404,110.056958 373.598404,110.376292 L373.598404,115.267526 C373.598404,115.550507 373.96122,115.666693 374.125876,115.436459 L377.97856,110.049117 C378.09831,109.881609 378.290766,109.78253 378.497478,109.78253 L411.42242,109.78253 C413.84594,109.78253 415.81113,107.817341 415.81113,105.393108 L415.81113,96.4581608 C415.811842,94.0339283 413.846653,92.0687388 411.42242,92.0687388 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 377.95575,
    cy: 100.912448,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 385.233438,
    cy: 100.912448,
    r: 1.44555827
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 392.510412,
    cy: 100.912448,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 399.787387,
    cy: 100.912448,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 407.065074,
    cy: 100.912448,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.544695,131.242085 L150.36871,131.242085 C152.792943,131.242085 154.75742,133.207274 154.75742,135.630794 L154.75742,144.565741 C154.75742,146.802507 153.085191,148.648659 150.922556,148.920236 C150.60536,148.960153 150.36871,149.229591 150.36871,149.548926 L150.36871,154.440159 C150.36871,154.722428 150.005895,154.839327 149.841238,154.60838 L145.988555,149.221038 C145.868804,149.05353 145.675636,148.95445 145.469636,148.95445 L112.544695,148.95445 C110.120462,148.95445 108.155273,146.989261 108.155273,144.565028 L108.155273,135.630081 C108.155273,133.207274 110.120462,131.242085 112.544695,131.242085 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 146.011364,
    cy: 140.085794,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 138.733677,
    cy: 140.085794,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 131.456702,
    cy: 140.085794,
    r: 1.44484547
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 124.179728,
    cy: 140.085794,
    r: 1.44555827
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    cx: 116.902041,
    cy: 140.085794,
    r: 1.44555827
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.973551,71.4545647 L272.03368,71.4545647 C268.231605,71.4545647 265.150171,68.3724178 265.150171,64.5703429 C265.150171,60.7682681 268.231605,57.6861212 272.03368,57.6861212 L340.973551,57.6861212 C344.775626,57.6861212 347.85706,60.7682681 347.85706,64.5703429 C347.85706,68.3724178 344.775626,71.4545647 340.973551,71.4545647",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.973551,71.4545647 L272.03368,71.4545647 C268.231605,71.4545647 265.150171,68.3724178 265.150171,64.5703429 C265.150171,60.7682681 268.231605,57.6861212 272.03368,57.6861212 L340.973551,57.6861212 C344.775626,57.6861212 347.85706,60.7682681 347.85706,64.5703429 C347.85706,68.3724178 344.775626,71.4545647 340.973551,71.4545647 Z",
    id: "Path",
    stroke: "#495AD6",
    strokeWidth: 0.638668742
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#495AD6",
    strokeWidth: 1.19180149,
    cx: 336.302573,
    cy: 64.096331,
    r: 3.66094047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.891463,
    y1: 66.6845076,
    x2: 340.912251,
    y2: 68.7060082,
    id: "Path",
    stroke: "#495AD6",
    strokeWidth: 1.19180149,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.543371,258.688575 L219.200236,258.688575 C216.165847,258.688575 213.705974,256.229415 213.705974,253.195026 L213.705974,235.851891 C213.705974,232.816788 216.165847,230.357629 219.200236,230.357629 L236.543371,230.357629 C239.577761,230.357629 242.037633,232.816788 242.037633,235.851891 L242.037633,253.195026 C242.037633,256.229415 239.577048,258.688575 236.543371,258.688575",
    id: "Path",
    fill: "#D8BF2D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.379849,258.688575 L214.036713,258.688575 C211.002324,258.688575 208.542451,256.229415 208.542451,253.195026 L208.542451,235.851891 C208.542451,232.816788 211.002324,230.357629 214.036713,230.357629 L231.379849,230.357629 C234.414238,230.357629 236.87411,232.816788 236.87411,235.851891 L236.87411,253.195026 C236.87411,256.229415 234.414238,258.688575 231.379849,258.688575",
    id: "Path",
    fill: "#FFE75B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.362754,239.175677 L227.495089,243.87089 C227.997613,244.160999 227.997613,244.885204 227.495089,245.175314 L219.362754,249.870527 C218.860943,250.160636 218.232967,249.797821 218.232967,249.218315 L218.232967,239.827889 C218.232967,239.248382 218.860231,238.885567 219.362754,239.175677",
    id: "Path",
    fill: "#193091",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.94371,258.688575 L393.27097,258.688575 C389.304951,258.688575 386.08951,255.473134 386.08951,251.507116 L386.08951,228.834375 C386.08951,224.868356 389.304951,221.652203 393.27097,221.652203 L415.94371,221.652203 C419.909729,221.652203 423.125882,224.868356 423.125882,228.834375 L423.125882,251.507116 C423.125882,255.473134 419.910442,258.688575 415.94371,258.688575",
    id: "Path",
    fill: "#CF213A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.193495,258.688575 L386.521467,258.688575 C382.554736,258.688575 379.339295,255.473134 379.339295,251.507116 L379.339295,228.834375 C379.339295,224.868356 382.554736,221.652203 386.521467,221.652203 L409.193495,221.652203 C413.160226,221.652203 416.375667,224.868356 416.375667,228.834375 L416.375667,251.507116 C416.37638,255.473134 413.160939,258.688575 409.193495,258.688575",
    id: "Path",
    fill: "#F63954",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.307847,230.739689 C402.307847,233.196711 400.315572,235.188987 397.857837,235.188987 C395.400103,235.188987 393.407827,233.196711 393.407827,230.739689 C393.407827,228.281955 395.400103,226.289679 397.857837,226.289679 C400.315572,226.289679 402.307847,228.281955 402.307847,230.739689",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.134216,245.806142 L407.134216,252.374593 C407.134216,252.968355 406.653076,253.449495 406.059313,253.449495 L389.656361,253.449495 C389.062599,253.449495 388.581459,252.968355 388.581459,252.374593 L388.581459,245.806142 C388.581459,240.682536 392.734944,236.529051 397.857837,236.529051 C402.982156,236.529051 407.134216,240.682536 407.134216,245.806142",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.032623,79.3851768 L300.471546,79.3851768 C299.866379,79.3851768 299.376686,78.8954832 299.376686,78.2910289 C299.376686,77.6865746 299.867092,77.196881 300.471546,77.196881 L315.032623,77.196881 C315.637078,77.196881 316.126771,77.6865746 316.126771,78.2910289 C316.126771,78.8954832 315.636365,79.3851768 315.032623,79.3851768",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.600116,79.3851768 L319.062081,79.3851768 C318.457627,79.3851768 317.967933,78.8954832 317.967933,78.2910289 C317.967933,77.6865746 318.45834,77.196881 319.062081,77.196881 L329.600116,77.196881 C330.20457,77.196881 330.694264,77.6865746 330.694264,78.2910289 C330.694264,78.8954832 330.20457,79.3851768 329.600116,79.3851768",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.657937,84.1965764 L300.470833,84.1965764 C299.866379,84.1965764 299.377398,83.7068828 299.377398,83.1024285 C299.377398,82.4979741 299.867092,82.0082806 300.470833,82.0082806 L306.657937,82.0082806 C307.262391,82.0082806 307.752085,82.4979741 307.752085,83.1024285 C307.752085,83.7068828 307.261678,84.1965764 306.657937,84.1965764",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.600116,84.1965764 L310.330282,84.1965764 C309.725828,84.1965764 309.236134,83.7068828 309.236134,83.1024285 C309.236134,82.4979741 309.726541,82.0082806 310.330282,82.0082806 L329.600116,82.0082806 C330.20457,82.0082806 330.694264,82.4979741 330.694264,83.1024285 C330.694264,83.7068828 330.20457,84.1965764 329.600116,84.1965764",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.665823,89.0079759 L300.471546,89.0079759 C299.866379,89.0079759 299.376686,88.5182824 299.376686,87.913828 C299.376686,87.3093737 299.867092,86.8196801 300.471546,86.8196801 L319.665823,86.8196801 C320.270277,86.8196801 320.759971,87.3093737 320.759971,87.913828 C320.759971,88.5182824 320.269564,89.0079759 319.665823,89.0079759",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.600116,89.0079759 L323.413012,89.0079759 C322.807845,89.0079759 322.318864,88.5182824 322.318864,87.913828 C322.318864,87.3093737 322.808558,86.8196801 323.413012,86.8196801 L329.600116,86.8196801 C330.20457,86.8196801 330.694264,87.3093737 330.694264,87.913828 C330.694264,88.5182824 330.20457,89.0079759 329.600116,89.0079759",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.641259,191.147217 L79.8079319,191.147217 C78.3024985,191.147217 77.082185,189.926904 77.082185,188.422183 L77.082185,162.761385 C77.082185,161.256665 78.3024985,160.036351 79.8079319,160.036351 L130.641259,160.036351 C132.14598,160.036351 133.366294,161.256665 133.366294,162.761385 L133.366294,188.422183 C133.367006,189.926904 132.146693,191.147217 130.641259,191.147217",
    id: "Path",
    fill: "#193091",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.4750544,
    y1: 164.239019,
    x2: 130.97485,
    y2: 164.239019,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.638668742,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.23924,162.10062 C130.23924,162.444902 129.959823,162.72432 129.61554,162.72432 C129.271258,162.72432 128.99184,162.444902 128.99184,162.10062 C128.99184,161.756337 129.271258,161.47692 129.61554,161.47692 C129.959823,161.47692 130.23924,161.756337 130.23924,162.10062",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.986734,162.10062 C126.986734,162.444902 126.707316,162.72432 126.363034,162.72432 C126.018752,162.72432 125.739334,162.444902 125.739334,162.10062 C125.739334,161.756337 126.018752,161.47692 126.363034,161.47692 C126.707316,161.47692 126.986734,161.756337 126.986734,162.10062",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.734941,162.10062 C123.734941,162.444902 123.455523,162.72432 123.111241,162.72432 C122.766958,162.72432 122.487541,162.444902 122.487541,162.10062 C122.487541,161.756337 122.766958,161.47692 123.111241,161.47692 C123.455523,161.47692 123.734941,161.756337 123.734941,162.10062",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0750439,168.426719 L80.3361167,168.426719 C79.8606791,168.426719 79.4750544,168.041094 79.4750544,167.565657 C79.4750544,167.089506 79.8606791,166.703882 80.3361167,166.703882 L89.0750439,166.703882 C89.5504815,166.703882 89.9361062,167.089506 89.9361062,167.565657 C89.9361062,168.041094 89.5504815,168.426719 89.0750439,168.426719",
    id: "Path",
    fill: "#6589D1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0750439,172.406281 L80.3361167,172.406281 C79.8606791,172.406281 79.4750544,172.020656 79.4750544,171.545219 C79.4750544,171.069068 79.8606791,170.683444 80.3361167,170.683444 L89.0750439,170.683444 C89.5504815,170.683444 89.9361062,171.069068 89.9361062,171.545219 C89.9361062,172.020656 89.5504815,172.406281 89.0750439,172.406281",
    id: "Path",
    fill: "#6589D1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0750439,176.386556 L80.3361167,176.386556 C79.8606791,176.386556 79.4750544,176.000931 79.4750544,175.525494 C79.4750544,175.049343 79.8606791,174.663719 80.3361167,174.663719 L89.0750439,174.663719 C89.5504815,174.663719 89.9361062,175.049343 89.9361062,175.525494 C89.9361062,176.000931 89.5504815,176.386556 89.0750439,176.386556",
    id: "Path",
    fill: "#6589D1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0750439,180.366118 L80.3361167,180.366118 C79.8606791,180.366118 79.4750544,179.980493 79.4750544,179.505056 C79.4750544,179.028905 79.8606791,178.643281 80.3361167,178.643281 L89.0750439,178.643281 C89.5504815,178.643281 89.9361062,179.028905 89.9361062,179.505056 C89.9361062,179.980493 89.5504815,180.366118 89.0750439,180.366118",
    id: "Path",
    fill: "#6589D1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0750439,184.34568 L80.3361167,184.34568 C79.8606791,184.34568 79.4750544,183.960055 79.4750544,183.484618 C79.4750544,183.008467 79.8606791,182.622843 80.3361167,182.622843 L89.0750439,182.622843 C89.5504815,182.622843 89.9361062,183.008467 89.9361062,183.484618 C89.9361062,183.960055 89.5504815,184.34568 89.0750439,184.34568",
    id: "Path",
    fill: "#6589D1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0750439,188.325955 L80.3361167,188.325955 C79.8606791,188.325955 79.4750544,187.94033 79.4750544,187.464893 C79.4750544,186.988742 79.8606791,186.603117 80.3361167,186.603117 L89.0750439,186.603117 C89.5504815,186.603117 89.9361062,186.988742 89.9361062,187.464893 C89.9361062,187.94033 89.5504815,188.325955 89.0750439,188.325955",
    id: "Path",
    fill: "#6589D1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.113787,168.426719 L92.4544284,168.426719 C91.978278,168.426719 91.5926533,168.041094 91.5926533,167.565657 C91.5926533,167.089506 91.978278,166.703882 92.4544284,166.703882 L130.113787,166.703882 C130.589225,166.703882 130.97485,167.089506 130.97485,167.565657 C130.97485,168.041094 130.589225,168.426719 130.113787,168.426719",
    id: "Path",
    fill: "#3B5FB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.113787,172.406281 L92.4544284,172.406281 C91.978278,172.406281 91.5926533,172.020656 91.5926533,171.545219 C91.5926533,171.069068 91.978278,170.683444 92.4544284,170.683444 L130.113787,170.683444 C130.589225,170.683444 130.97485,171.069068 130.97485,171.545219 C130.97485,172.020656 130.589225,172.406281 130.113787,172.406281",
    id: "Path",
    fill: "#3B5FB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.113787,176.386556 L92.4544284,176.386556 C91.978278,176.386556 91.5926533,176.000931 91.5926533,175.525494 C91.5926533,175.049343 91.978278,174.663719 92.4544284,174.663719 L130.113787,174.663719 C130.589225,174.663719 130.97485,175.049343 130.97485,175.525494 C130.97485,176.000931 130.589225,176.386556 130.113787,176.386556",
    id: "Path",
    fill: "#3B5FB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.113787,180.366118 L92.4544284,180.366118 C91.978278,180.366118 91.5926533,179.980493 91.5926533,179.505056 C91.5926533,179.028905 91.978278,178.643281 92.4544284,178.643281 L130.113787,178.643281 C130.589225,178.643281 130.97485,179.028905 130.97485,179.505056 C130.97485,179.980493 130.589225,180.366118 130.113787,180.366118",
    id: "Path",
    fill: "#3B5FB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.113787,184.34568 L92.4544284,184.34568 C91.978278,184.34568 91.5926533,183.960055 91.5926533,183.484618 C91.5926533,183.008467 91.978278,182.622843 92.4544284,182.622843 L130.113787,182.622843 C130.589225,182.622843 130.97485,183.008467 130.97485,183.484618 C130.97485,183.960055 130.589225,184.34568 130.113787,184.34568",
    id: "Path",
    fill: "#3B5FB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.113787,188.325955 L92.4544284,188.325955 C91.978278,188.325955 91.5926533,187.94033 91.5926533,187.464893 C91.5926533,186.988742 91.978278,186.603117 92.4544284,186.603117 L130.113787,186.603117 C130.589225,186.603117 130.97485,186.988742 130.97485,187.464893 C130.97485,187.94033 130.589225,188.325955 130.113787,188.325955",
    id: "Path",
    fill: "#3B5FB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#DEE3FC",
    strokeWidth: 0.563111949,
    cx: 371.985338,
    cy: 23.2272339,
    r: 23.1695619
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.129064,23.2272339 C392.129064,34.3519025 383.11072,43.3709601 371.985338,43.3709601 C360.859957,43.3709601 351.841612,34.3519025 351.841612,23.2272339 C351.841612,12.1025653 360.859957,3.08350773 371.985338,3.08350773 C383.11072,3.08350773 392.129064,12.1025653 392.129064,23.2272339",
    id: "Path",
    fill: "#3945BA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.819372,23.2272339 C373.819372,24.2401226 372.998227,25.0605553 371.986051,25.0605553 C370.973162,25.0605553 370.15273,24.2401226 370.15273,23.2272339 C370.15273,22.2143452 370.973162,21.3939125 371.986051,21.3939125 C372.997514,21.3939125 373.819372,22.2143452 373.819372,23.2272339",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.785754,22.8665571 L371.785754,22.8665571 C371.508475,23.0198091 371.159916,22.9200171 371.005951,22.642738 L365.081158,11.9571541 C364.927906,11.6805878 365.027698,11.3313158 365.304977,11.1780638 C365.581544,11.024099 365.930816,11.1246038 366.084068,11.4011702 L372.008861,22.086754 C372.162825,22.3640332 372.063033,22.7133051 371.785754,22.8665571",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.276161,23.5180563 L372.276161,23.5180563 C372.49998,23.2942371 372.863508,23.2942371 373.08804,23.5180563 L378.212358,28.6430878 C378.436178,28.866907 378.436178,29.230435 378.212358,29.4542541 C377.989252,29.6780733 377.625724,29.6780733 377.401192,29.4542541 L372.276161,24.3292226 C372.053054,24.1061162 372.053054,23.7418755 372.276161,23.5180563",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.108653,
    y1: 7.10369937,
    x2: 372.108653,
    y2: 4.78709958,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.42559987,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.10816,
    y1: 23.3498355,
    x2: 390.42476,
    y2: 23.3498355,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.42559987,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.862024,
    y1: 39.3500556,
    x2: 371.862024,
    y2: 41.6666554,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.42559987,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.861804,
    y1: 23.1039195,
    x2: 353.545204,
    y2: 23.1039195,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.42559987,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(354.974368, 6.479999)",
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.05612318,
    y1: 2.72218295,
    x2: 7.89782328,
    y2: 0.715651135,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.036022,
    y1: 8.7916744,
    x2: 33.041841,
    y2: 7.63337451,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.9658177,
    y1: 30.7715732,
    x2: 26.1241176,
    y2: 32.778105,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.98591893,
    y1: 24.7020818,
    x2: 0.980099911,
    y2: 25.8603816,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-12)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(355.687168, 6.479999)",
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.39643338,
    y1: 8.57854722,
    x2: 0.390614364,
    y2: 7.42024733,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.4668578,
    y1: 2.84549734,
    x2: 25.6251577,
    y2: 0.838965524,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.1999077,
    y1: 24.9152089,
    x2: 32.2064395,
    y2: 26.0735088,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-18)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.12948326,
    y1: 30.6482588,
    x2: 6.97118337,
    y2: 32.6547906,
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935,
    strokeLinecap: "round",
    mask: "url(#mask-20)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M96.6970136,139.829186 L71.2536199,139.829186 C67.4864723,139.829186 64.4328373,136.775551 64.4328373,133.008403 L64.4328373,107.565009 C64.4328373,103.797862 67.4864723,100.744227 71.2536199,100.744227 L96.6970136,100.744227 C100.464161,100.744227 103.517796,103.797862 103.517796,107.565009 L103.517796,133.008403 C103.517796,136.775551 100.464161,139.829186 96.6970136,139.829186",
    id: "Path",
    fill: "#193091",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0240722,136.443386 L66.8684747,136.443386 C63.8504798,136.443386 61.4034376,133.996344 61.4034376,130.978349 L61.4034376,102.822751 C61.4034376,99.8047565 63.8504798,97.3584272 66.8684747,97.3584272 L95.0240722,97.3584272 C98.0420671,97.3584272 100.489109,99.8047565 100.489109,102.822751 L100.489109,130.978349 C100.489109,133.997057 98.0413543,136.443386 95.0240722,136.443386",
    id: "Path",
    fill: "#7E89FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0240722,136.443386 L66.8684747,136.443386 C63.8504798,136.443386 61.4034376,133.996344 61.4034376,130.978349 L61.4034376,102.822751 C61.4034376,99.8047565 63.8504798,97.3584272 66.8684747,97.3584272 L95.0240722,97.3584272 C98.0420671,97.3584272 100.489109,99.8047565 100.489109,102.822751 L100.489109,130.978349 C100.489109,133.997057 98.0413543,136.443386 95.0240722,136.443386 Z",
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7143088,112.425592 L87.5097352,112.425592 L87.5097352,110.186688 C87.5097352,106.511491 84.5209651,103.522008 80.8457687,103.522008 C77.1705722,103.522008 74.1825149,106.511491 74.1825149,110.186688 L74.1825149,112.425592 L74.1376085,112.425592 C73.1047614,112.425592 72.2672214,113.263132 72.2672214,114.295979 L72.2672214,122.733392 C72.2672214,123.766239 73.1047614,124.603066 74.1376085,124.603066 L87.7143088,124.603066 C88.7471559,124.603066 89.5839831,123.766239 89.5839831,122.733392 L89.5839831,114.295979 C89.5839831,113.263132 88.7471559,112.425592 87.7143088,112.425592 M75.8689995,110.186688 C75.8689995,107.443121 78.1022017,105.210631 80.8450559,105.210631 C83.5886228,105.210631 85.821825,107.443121 85.821825,110.186688 L85.821825,112.425592 L75.8689995,112.425592 L75.8689995,110.186688 Z",
    id: "Shape",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1203132,116.762267 C83.1203132,115.415075 81.8950102,114.354429 80.4986351,114.632421 C79.6753512,114.796365 78.9924888,115.472099 78.820704,116.293957 C78.6139921,117.284749 79.0823016,118.18858 79.8492743,118.636931 C80.0053775,118.728169 80.0937647,118.899241 80.0467199,119.073877 L79.6682232,120.470252 C79.4436912,121.300664 80.0688167,122.117533 80.9291662,122.117533 C81.7895158,122.117533 82.4146413,121.300664 82.1893965,120.470252 L81.8151766,119.088846 C81.767419,118.912072 81.8586574,118.738861 82.0176117,118.648336 C82.6755261,118.275541 83.1203132,117.572721 83.1203132,116.762267",
    id: "Path",
    fill: "#7E89FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7820831,127.561899 L73.0691214,127.561899 C72.6257598,127.561899 72.2672214,127.202648 72.2672214,126.759999 C72.2672214,126.31735 72.6257598,125.958099 73.0691214,125.958099 L88.7820831,125.958099 C89.2247319,125.958099 89.5839831,126.31735 89.5839831,126.759999 C89.5839831,127.202648 89.2247319,127.561899 88.7820831,127.561899",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7820831,130.279805 L73.0691214,130.279805 C72.6257598,130.279805 72.2672214,129.920554 72.2672214,129.477905 C72.2672214,129.035256 72.6257598,128.676005 73.0691214,128.676005 L88.7820831,128.676005 C89.2247319,128.676005 89.5839831,129.035256 89.5839831,129.477905 C89.5839831,129.920554 89.2247319,130.279805 88.7820831,130.279805",
    id: "Path",
    fill: "#DEE3FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.565998,185.771993 L389.586507,185.771993 C387.369699,185.771993 385.570592,183.974311 385.570592,181.756078 L385.570592,166.776587 C385.570592,164.559779 387.368986,162.761385 389.586507,162.761385 L404.565998,162.761385 C406.782805,162.761385 408.581912,164.559067 408.581912,166.776587 L408.581912,181.756078 C408.581912,183.974311 406.783518,185.771993 404.565998,185.771993",
    id: "Path",
    fill: "#193091",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.580908,183.778291 L387.004746,183.778291 C385.228448,183.778291 383.787167,182.337723 383.787167,180.561425 L383.787167,163.985263 C383.787167,162.208965 385.227735,160.767684 387.004746,160.767684 L403.580908,160.767684 C405.357206,160.767684 406.797774,162.208252 406.797774,163.985263 L406.797774,180.561425 C406.797774,182.338435 405.357918,183.778291 403.580908,183.778291",
    id: "Path",
    fill: "#7E89FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.580908,183.778291 L387.004746,183.778291 C385.228448,183.778291 383.787167,182.337723 383.787167,180.561425 L383.787167,163.985263 C383.787167,162.208965 385.227735,160.767684 387.004746,160.767684 L403.580908,160.767684 C405.357206,160.767684 406.797774,162.208252 406.797774,163.985263 L406.797774,180.561425 C406.797774,182.338435 405.357918,183.778291 403.580908,183.778291 Z",
    id: "Path",
    stroke: "#DEE3FC",
    strokeWidth: 0.712799935
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.644302,179.145092 C390.579437,179.145092 390.514572,179.136538 390.450421,179.118005 C390.071211,179.012511 389.850956,178.61762 389.958589,178.239836 L393.438478,165.921227 C393.544685,165.541305 393.941002,165.320337 394.31736,165.429395 C394.69657,165.535603 394.916825,165.929781 394.809192,166.308278 L391.329303,178.626173 C391.240916,178.940518 390.955083,179.145092 390.644302,179.145092",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.462888,179.145092 C396.398023,179.145092 396.333158,179.136538 396.269006,179.118005 C395.889797,179.012511 395.669542,178.61762 395.777174,178.239836 L399.257777,165.921227 C399.363984,165.541305 399.7603,165.320337 400.136659,165.429395 C400.515868,165.535603 400.736124,165.929781 400.628491,166.308278 L397.147889,178.626173 C397.059502,178.940518 396.773669,179.145092 396.462888,179.145092",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.451775,170.195176 L389.133879,170.195176 C388.739701,170.195176 388.421079,169.876554 388.421079,169.482376 C388.421079,169.088197 388.739701,168.769576 389.133879,168.769576 L401.451775,168.769576 C401.845953,168.769576 402.164575,169.088197 402.164575,169.482376 C402.164575,169.876554 401.845953,170.195176 401.451775,170.195176",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.451775,175.822018 L389.133879,175.822018 C388.739701,175.822018 388.421079,175.503397 388.421079,175.109218 C388.421079,174.71504 388.739701,174.396419 389.133879,174.396419 L401.451775,174.396419 C401.845953,174.396419 402.164575,174.71504 402.164575,175.109218 C402.164575,175.503397 401.845953,175.822018 401.451775,175.822018",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.787863,112.680775 L117.879289,112.680775 C117.3397,112.680775 116.902041,112.243115 116.902041,111.704239 C116.902041,111.164649 117.3397,110.72699 117.879289,110.72699 L126.787863,110.72699 C127.327452,110.72699 127.764399,111.164649 127.764399,111.704239 C127.764399,112.243115 127.327452,112.680775 126.787863,112.680775",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.762014,117.016737 L117.879289,117.016737 C117.3397,117.016737 116.902041,116.579077 116.902041,116.040201 C116.902041,115.500611 117.3397,115.062952 117.879289,115.062952 L135.762014,115.062952 C136.301604,115.062952 136.73855,115.500611 136.73855,116.040201 C136.73855,116.579077 136.301604,117.016737 135.762014,117.016737",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.991315,121.353411 L117.879289,121.353411 C117.3397,121.353411 116.902041,120.915752 116.902041,120.376875 C116.902041,119.837286 117.3397,119.399627 117.879289,119.399627 L119.991315,119.399627 C120.530905,119.399627 120.967851,119.837286 120.967851,120.376875 C120.967851,120.915039 120.530905,121.353411 119.991315,121.353411",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.762014,121.353411 L123.310112,121.353411 C122.770522,121.353411 122.333576,120.915752 122.333576,120.376875 C122.333576,119.837286 122.770522,119.399627 123.310112,119.399627 L135.762014,119.399627 C136.301604,119.399627 136.73855,119.837286 136.73855,120.376875 C136.73855,120.915039 136.301604,121.353411 135.762014,121.353411",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.762014,112.680775 L130.362555,112.680775 C129.822965,112.680775 129.385306,112.243115 129.385306,111.704239 C129.385306,111.164649 129.822965,110.72699 130.362555,110.72699 L135.762014,110.72699 C136.301604,110.72699 136.73855,111.164649 136.73855,111.704239 C136.73855,112.243115 136.301604,112.680775 135.762014,112.680775",
    id: "Path",
    fill: "#F0F4FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5238746,245.920902 C84.3634363,245.920902 83.2771292,246.239524 82.3476381,246.79337 C81.9741309,243.467445 79.1535816,240.881407 75.7278651,240.881407 C72.0483918,240.881407 69.0653241,243.865187 69.0653241,247.544661 C69.0653241,247.791289 69.0802929,248.034354 69.1059537,248.273142 C68.8008753,248.216118 68.4858178,248.184755 68.1636322,248.184755 C65.3537749,248.184755 63.0763791,250.462864 63.0763791,253.272008 C63.0763791,256.081866 65.3537749,258.359974 68.1636322,258.359974 L85.5238746,258.359974 C88.9588575,258.359974 91.7430541,255.575778 91.7430541,252.140082 C91.7430541,248.705099 88.9588575,245.920902 85.5238746,245.920902",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.634391942,
    y1: 258.357123,
    x2: 464.111166,
    y2: 258.357123,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.794059128,
    strokeLinecap: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubImg2);
export default __webpack_public_path__ + "static/media/hub_img2.11f008608d54042dd1a105f8b47951e1.svg";
export { ForwardRef as ReactComponent };